import { render, staticRenderFns } from "./PerformanceInquiry.vue?vue&type=template&id=6a68b308&scoped=true&"
import script from "./PerformanceInquiry.vue?vue&type=script&lang=js&"
export * from "./PerformanceInquiry.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceInquiry.vue?vue&type=style&index=0&id=6a68b308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a68b308",
  null
  
)

export default component.exports